import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IEAreaFilter } from '../interfaces/eregion-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IEArea } from '../interfaces/earea';

@Injectable({ providedIn: 'root' })
export class EngineiusAreaService extends EditService<IEArea, IEAreaFilter> {
  url = '/api/eareas';
  entityTitle = 'EngineiusArea';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(): Promise<any> {
    return this.handleRequest(
      this.http.get<IEArea[]>(`${this.url}/getAll`),
      this.handlersFactory.getForReadAll(),
    );
  }

  save(area: IEArea, newarea: boolean) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });

    let successMsg = newarea ? 'Area added.' : 'Area updated.';

    return this.handleRequest(
      this.http.post(this.url + '/save', area, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
}
